<template>
  <header class="header">
    <Navbar tel="3003 0256"></Navbar>
    <div class="header-content">
      <Logo width="176" height="40"></Logo>
    </div>
  </header>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Logo from '@/components/Logo.vue';

export default {
  name: 'Header',
  components: {
    Navbar,
    Logo
  }
};
</script>

<style lang="scss">
.header {
  display: flex;
  flex-direction: column;
  margin-bottom: 56px;

  &-content {
    padding: 24px 0;
    border-bottom: 1px solid var(--color-positive-normal);
    text-align: center;
  }
}
</style>
